import { render, staticRenderFns } from "./CreateWebCustomerForm.vue?vue&type=template&id=19d6b162&scoped=true"
import script from "./CreateWebCustomerForm.vue?vue&type=script&lang=js"
export * from "./CreateWebCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CreateWebCustomerForm.vue?vue&type=style&index=0&id=19d6b162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6b162",
  null
  
)

export default component.exports